/**
 * OnboardingPage saga functions
 */
import { call, put, takeLatest, take } from 'redux-saga/effects';
import { handleError } from '../../Lib/Utils/saga-utils';
import { actions } from './slice';
import FactoryAPI from '../../Lib/Api/factory.ts';

export function* create({ payload: { userId, factory }, resolve, reject }) {
  try {
    const chan = yield call(FactoryAPI.create, factory, userId);
    while (true) {
      const event = yield take(chan);
      if (event.progressEvent) {
        yield put(
          actions.uploadFileProgress({
            fileName: event.fileName,
            progressEvent: event.progressEvent,
          }),
        );
      } else if (event.data) {
        yield put(actions.createSuccess(event.data));
        yield call(resolve, event.data);
      }
    }
  } catch (err) {
    yield handleError(actions.createError, err, reject);
  }
}

export function* updateFile({
  payload: { file, signedUrl, fileName },
  resolve,
  reject,
}) {
  try {
    const chan = yield call(FactoryAPI.updateFile, file, signedUrl, fileName);
    while (true) {
      const event = yield take(chan);
      if (event.progressEvent) {
        yield put(
          actions.uploadFileProgress({
            fileName: event.fileName,
            progressEvent: event.progressEvent,
          }),
        );
      } else if (event.data) {
        yield call(resolve, event.data);
      }
    }
  } catch (err) {
    yield handleError(actions.updateError, err, reject);
  }
}

export function* get({ payload: { userId, factoryId }, resolve, reject }) {
  try {
    const response = yield call(FactoryAPI.get, factoryId, userId);
    yield put(actions.getSuccess(response));
    yield call(resolve, response);
  } catch (err) {
    yield handleError(actions.getError, err, reject);
  }
}

export function* getAll({ payload: { userId, params } }) {
  try {
    const response = yield call(FactoryAPI.getAll, params, userId);
    yield put(actions.getAllSuccess(response));
  } catch (err) {
    yield handleError(actions.getAllError, err);
  }
}

export function* update({
  payload: { userId, factoryId, updates },
  resolve,
  reject,
}) {
  try {
    const response = yield call(FactoryAPI.update, updates, factoryId, userId);
    yield put(actions.updateSuccess(response));
    yield call(resolve, response);
  } catch (err) {
    yield handleError(actions.updateError, err, reject);
  }
}

export function* deleteFactory({ payload: { userId, factoryId } }) {
  try {
    const response = yield call(FactoryAPI.delete, factoryId, userId);
    yield put(actions.deleteSuccess(response));
  } catch (err) {
    yield handleError(actions.deleteError, err);
  }
}

function* factorySaga() {
  yield takeLatest(actions.create.type, create);
  yield takeLatest(actions.get.type, get);
  yield takeLatest(actions.getAll.type, getAll);
  yield takeLatest(actions.update.type, update);
  yield takeLatest(actions.delete.type, deleteFactory);
  yield takeLatest(actions.updateFile.type, updateFile);
}

export default factorySaga;
